const MAX_SORT = Number.MAX_SAFE_INTEGER;

const toSortableNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : MAX_SORT;
};

const extractName = (item = {}) =>
  item.name ??
  item.subject_name ??
  item.subject ??
  item.topic_name ??
  item.subtopic_name ??
  item.sub_topic_name ??
  "";

const extractId = (item = {}) =>
  item.id ??
  item.subject_id ??
  item.topic_id ??
  item.subtopic_id ??
  item.sub_topic_id ??
  MAX_SORT;

export const compareHierarchyItems = (a = {}, b = {}) => {
  const aSort = toSortableNumber(a.sort_order ?? a.order ?? a.position);
  const bSort = toSortableNumber(b.sort_order ?? b.order ?? b.position);
  if (aSort !== bSort) return aSort - bSort;

  const byName = String(extractName(a)).localeCompare(String(extractName(b)), undefined, {
    sensitivity: "base",
    numeric: true,
  });
  if (byName !== 0) return byName;

  return toSortableNumber(extractId(a)) - toSortableNumber(extractId(b));
};

const normalizeHierarchyCollection = (items) => {
  if (Array.isArray(items)) return items;
  if (items && typeof items === "object") return Object.values(items);
  return [];
};

export const sortHierarchyItems = (items) =>
  [...normalizeHierarchyCollection(items)].sort(compareHierarchyItems);
